import {Routes} from '@angular/router';
import {userStoreOrGuard} from './guards';
import {purchaseOrderResolver} from "./resolver/purchase-order.resolver";
import {invoiceDocumentResolver, invoiceDocumentValidationAccessResolver} from "./resolver/invoice-document.resolver";

export const routes: Routes = [
  {
    path: 'purchase-order',
    children: [
      {
        path: 'edit/:uuid',
        resolve: { purchaseOrderLoaded: purchaseOrderResolver },
        loadComponent: () => import('./purchase-order-form/purchase-order-form.component'),
        canActivate: [
          userStoreOrGuard(
            [[store => store.isBuyer(), null],
            [store => store.isAdmin(), null]]
          )
        ],
      },
      {
        path: 'create',
        loadComponent: () => import('./purchase-order-form/purchase-order-form.component'),
        canActivate: [
          userStoreOrGuard(
            [[store => store.isBuyer(), null],
            [store => store.isAdmin(), null]]
          )
        ],
      },
      {
        path: ':uuid',
        resolve: { purchaseOrderLoaded: purchaseOrderResolver },
        children: [
          {
            path: 'validation',
            children: [
              {
                path: 'amount',
                loadComponent: () => import('./purchase-order-validation/purchase-order-validation.component'),
                canActivate: [
                  userStoreOrGuard(
                    [[store => store.isDirector(), 'noDirectorRoleSnackbar']],
                    (route, router) => router.createUrlTree(['/purchase-order', route.parent?.parent?.paramMap.get('uuid')])
                  )
                ],
                data: {validationType: 'amount'}
              },
              {
                path: 'green-lights',
                loadComponent: () => import('./purchase-order-validation/purchase-order-validation.component'),
                canActivate: [
                  userStoreOrGuard(
                    [[store => store.isQhse(), 'noQhseRoleSnackbar']],
                    (route, router) => router.createUrlTree(['/purchase-order', route.parent?.parent?.paramMap.get('uuid')])
                  )
                ],
                data: {validationType: 'green-lights'}
              }
            ]
          },
          {
            path: 'complete',
            loadComponent: () => import('./purchase-order-form/purchase-order-form.component'),
            canActivate: [
              userStoreOrGuard(
                [[store => store.isAccountant(), 'noAccountantOrBuyerRoleSnackbar'],
                [store => store.isBuyer(), 'noAccountantOrBuyerRoleSnackbar'],
                [store => store.isAdmin(), null],]
              )
            ],
          },
          {path: '', loadComponent: () => import('./purchase-order-form/purchase-order-form.component')},
        ]
      }
    ]
  },
  {
    path: 'invoices',
    canActivate: [
      userStoreOrGuard(
        [[store => store.canReadInvoiceDocument(), null]]
      )
    ],
    children: [
      {
        path: ':invoiceDocumentUuid',
        children: [
          {
            path: '',
            loadComponent: () => import('./unmatched-invoices/invoice-document/invoice-document.component'),
            resolve: { invoiceDocumentLoaded: invoiceDocumentResolver },
          },
          {
            path: 'validation',
            loadComponent: () => import('./unmatched-invoices/invoice-document/invoice-document.component'),
            resolve: { invoiceDocumentLoaded: invoiceDocumentValidationAccessResolver },
            data: {validationType: 'department'}
          }
        ]
      },
      {
        path: '',
        loadComponent: () => import('./unmatched-invoices/unmatched-invoices.component')
      },
    ]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./in-app-notification/in-app-notification.component'),
    canActivate: [
      userStoreOrGuard(
        [[store => store.isQhse(), null],
        [store => store.isDirector(), null],
        [store => store.isAccountant(), null]]
      )
    ],
  },
  {
    path: 'admin',
    loadComponent: () => import('./admin/admin.component'),
    canActivate: [
      userStoreOrGuard(
        [[store => store.isAdmin(), null]]
      )
    ],
  },
  {
    path: 'not-found',
    loadComponent: () => import('./errors/not-found/not-found.component')
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./dashboard/dashboard.component')
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
